import merge from 'lodash/merge'
import type { ConfirmDialogOptions } from '@ztechapps/common.hook'

export const useTemplateConfirmDialog = (otherConfigs?: Record<any, Partial<ConfirmDialogOptions>>) => {
  let confirmDialogConfigs = {
    resetPassword: {
      text: `Do you want to reset password? This will instantly change or reset the password once you click the reset button `,
      title: `Reset password`,
      buttons: { confirm: { text: `Yes, Reset it!` } },
    },
    payWithCard: {
      text: `This will create a new Stripe payment link. Your customer can click this link to navigate directly to Stripe payment page. Do you wish to continue?`,
      title: `Create payment link`,
      buttons: { confirm: { text: `Yes, Create it!` } },
    },
    payWithBank: {
      text: `This will create a new Stripe bank transfer payment request and reply with the bank details your customer should wire money to. Continue?`,
      title: `Create bank transfer payment request`,
      buttons: { confirm: { text: `Yes, Create it!` } },
    },
  }
  confirmDialogConfigs = merge(confirmDialogConfigs, otherConfigs)

  const getConfirmConfig = (config) => {
    return confirmDialogConfigs[config] ?? {}
  }

  return { getConfirmConfig }
}
